var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTraining(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-training",
    viewBox: "0 0 78 64",
    width: 78,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "g826",
    transform: "matrix(6.6365889,0,0,6.6365889,7.2601514,-7.5150508)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path821",
    d: "m 2.7023337,7.2546076 c -0.042527,0 -0.085056,0.00623 -0.125626,0.019394 -0.2306114,0.074913 -0.4731455,0.122958 -0.7284905,0.122958 -0.2553455,0 -0.4978796,-0.048045 -0.7286687,-0.122958 -0.040569,-0.013166 -0.082921,-0.019394 -0.12544836,-0.019394 -1.10430214,0 -1.99881224,0.8982469 -1.99293976,2.0039731 0.00247,0.4672736 0.38666567,0.8430843 0.854117,0.8430843 H 3.8411565 c 0.4674513,0 0.8516266,-0.3758107 0.8541171,-0.8430843 C 4.7011474,8.1528545 3.8066359,7.2546076 2.7023337,7.2546076 Z",
    style: {
      opacity: 0.4,
      fill: "currentColor",
      fillOpacity: 1,
      strokeWidth: 0.01779411
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path819",
    d: "m 1.8482172,7.2110323 c 0.9434429,0 1.7082336,-0.7647907 1.7082336,-1.7082338 0,-0.9434429 -0.7647907,-1.7082341 -1.7082336,-1.7082341 -0.94344339,0 -1.70823463,0.7647912 -1.70823463,1.7082341 0,0.9434431 0.76479124,1.7082338 1.70823463,1.7082338 z",
    style: {
      opacity: 0.7,
      fill: "currentColor",
      fillOpacity: 1,
      strokeWidth: 0.01779411
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2",
    d: "M 9.6953602,1.7171325 2.4957659,1.7068041 C 2.0247564,1.7061284 1.8482172,1.8548419 1.8482172,2.3413323 v 1.0737059 c 0.4167373,0 0.8025137,0.1206446 1.1388227,0.3167348 V 3.0617594 c 0,0 0.00141,-0.1374569 0.046478,-0.1799831 0.045284,-0.042733 0.1832594,-0.036149 0.1832594,-0.036149 h 5.8458684 c 0,0 0.1107508,-0.00379 0.1466053,0.030985 0.041781,0.040522 0.041314,0.1696547 0.041314,0.1696547 v 4.7717157 c 0,0 0.00478,0.089237 -0.02191,0.119848 -0.022798,0.02615 -0.098875,0.032498 -0.098875,0.032498 H 8.2621953 c 0,0 -0.091272,-0.022904 -0.1194684,-0.056806 -0.025632,-0.030819 -0.030985,-0.1161965 -0.030985,-0.1161965 0,-0.2702595 0,-0.540519 0,-0.8107785 0,0 0.00181,-0.089209 -0.025821,-0.1188914 C 8.0567474,6.8363204 7.962672,6.831507 7.962672,6.831507 H 5.9847855 c 0,0 -0.086844,0.00724 -0.1145398,0.036149 -0.032089,0.033497 -0.036149,0.134384 -0.036149,0.134384 v 0.8004501 c 0,0 0.014569,0.089291 -0.010328,0.1213606 -0.028865,0.037181 -0.1333419,0.046478 -0.1333419,0.046478 H 4.6943699 c 0.3398678,0.296984 0.3724447,0.6891666 0.4893521,1.1388228 h 4.583937 c 0.47101,0 0.621728,-0.1222163 0.621728,-0.6087073 V 2.3464964 c 0,-0.4864904 -0.223017,-0.6286882 -0.6940268,-0.6293639 z",
    style: {
      opacity: 0.6,
      fill: "currentColor",
      fillOpacity: 1,
      strokeWidth: 0.01779411
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTraining);
export default __webpack_public_path__ + "static/media/icon-training.cd86d37a.svg";
export { ForwardRef as ReactComponent };